import { z } from 'zod';

export const Record = z.object({ id: z.string().uuid() });

export type Record = z.infer<typeof Record>;

/** A more semantic version */
export type HasID = z.infer<typeof Record>;
